import { JavaLong } from '../../../java/lang/JavaLong';
import { JavaObject } from '../../../java/lang/JavaObject';
import { Class } from '../../../java/lang/Class';

export class UvRaum extends JavaObject {

	/**
	 * Die eindeutige ID des Raums.
	 */
	public id: number = -1;

	/**
	 * Das Kürzel des Raums.
	 */
	public kuerzel: string = "";

	/**
	 * Die Beschreibung des Raumes.
	 */
	public beschreibung: string | null = "";

	/**
	 * Die Größe des Raumes an Arbeitsplätzen für Schüler.
	 */
	public groesse: number = -1;

	/**
	 * Die ID der Raumgruppe, falls der Raum zu einer solchen gehört.
	 */
	public idRaumgruppe: number | null = null;

	/**
	 * Das Datum, ab dem der Raum gültig ist.
	 */
	public gueltigVon: string = "";

	/**
	 * Das Datum, bis wann der Raum gültig ist. Ist kein Datum gesetzt, gilt der Raum unbegrenzt weiter.
	 */
	public gueltigBis: string | null = null;


	/**
	 * Leerer Standardkonstruktor.
	 */
	public constructor() {
		super();
	}

	/**
	 * Gibt eine String-Repräsentation des UvRaum-Objekts zurück.
	 *
	 * @return die String-Darstellung des Raums
	 */
	public toString(): string | null {
		return "UvRaum{id=" + this.id + ", kuerzel=" + this.kuerzel + ", gueltigVon=" + this.gueltigVon + ", gueltigBis=" + this.gueltigBis + "}";
	}

	/**
	 * Vergleicht, ob das aktuelle Objekt dasselbe ist wie ein anderes übergebenes Objekt.
	 *
	 * @param another das zu vergleichende Objekt
	 * @return true, falls die Objekte identisch sind, sonst false
	 */
	public equals(another: unknown | null): boolean {
		return (((another instanceof JavaObject) && (another.isTranspiledInstanceOf('de.svws_nrw.core.data.uv.UvRaum')))) && (this.id === (another as unknown as UvRaum).id);
	}

	/**
	 * Erzeugt den Hashcode zu Objekt auf Basis der ID.
	 *
	 * @return den HashCode
	 */
	public hashCode(): number {
		return JavaLong.hashCode((this.id));
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.core.data.uv.UvRaum';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.core.data.uv.UvRaum'].includes(name);
	}

	public static readonly class = new Class<UvRaum>('de.svws_nrw.core.data.uv.UvRaum');

	public static transpilerFromJSON(json: string): UvRaum {
		const obj = JSON.parse(json) as Partial<UvRaum>;
		const result = new UvRaum();
		if (obj.id === undefined)
			throw new Error('invalid json format, missing attribute id');
		result.id = obj.id;
		if (obj.kuerzel === undefined)
			throw new Error('invalid json format, missing attribute kuerzel');
		result.kuerzel = obj.kuerzel;
		result.beschreibung = (obj.beschreibung === undefined) ? null : obj.beschreibung === null ? null : obj.beschreibung;
		if (obj.groesse === undefined)
			throw new Error('invalid json format, missing attribute groesse');
		result.groesse = obj.groesse;
		result.idRaumgruppe = (obj.idRaumgruppe === undefined) ? null : obj.idRaumgruppe === null ? null : obj.idRaumgruppe;
		if (obj.gueltigVon === undefined)
			throw new Error('invalid json format, missing attribute gueltigVon');
		result.gueltigVon = obj.gueltigVon;
		result.gueltigBis = (obj.gueltigBis === undefined) ? null : obj.gueltigBis === null ? null : obj.gueltigBis;
		return result;
	}

	public static transpilerToJSON(obj: UvRaum): string {
		let result = '{';
		result += '"id" : ' + obj.id.toString() + ',';
		result += '"kuerzel" : ' + JSON.stringify(obj.kuerzel) + ',';
		result += '"beschreibung" : ' + ((obj.beschreibung === null) ? 'null' : JSON.stringify(obj.beschreibung)) + ',';
		result += '"groesse" : ' + obj.groesse.toString() + ',';
		result += '"idRaumgruppe" : ' + ((obj.idRaumgruppe === null) ? 'null' : obj.idRaumgruppe.toString()) + ',';
		result += '"gueltigVon" : ' + JSON.stringify(obj.gueltigVon) + ',';
		result += '"gueltigBis" : ' + ((obj.gueltigBis === null) ? 'null' : JSON.stringify(obj.gueltigBis)) + ',';
		result = result.slice(0, -1);
		result += '}';
		return result;
	}

	public static transpilerToJSONPatch(obj: Partial<UvRaum>): string {
		let result = '{';
		if (obj.id !== undefined) {
			result += '"id" : ' + obj.id.toString() + ',';
		}
		if (obj.kuerzel !== undefined) {
			result += '"kuerzel" : ' + JSON.stringify(obj.kuerzel) + ',';
		}
		if (obj.beschreibung !== undefined) {
			result += '"beschreibung" : ' + ((obj.beschreibung === null) ? 'null' : JSON.stringify(obj.beschreibung)) + ',';
		}
		if (obj.groesse !== undefined) {
			result += '"groesse" : ' + obj.groesse.toString() + ',';
		}
		if (obj.idRaumgruppe !== undefined) {
			result += '"idRaumgruppe" : ' + ((obj.idRaumgruppe === null) ? 'null' : obj.idRaumgruppe.toString()) + ',';
		}
		if (obj.gueltigVon !== undefined) {
			result += '"gueltigVon" : ' + JSON.stringify(obj.gueltigVon) + ',';
		}
		if (obj.gueltigBis !== undefined) {
			result += '"gueltigBis" : ' + ((obj.gueltigBis === null) ? 'null' : JSON.stringify(obj.gueltigBis)) + ',';
		}
		result = result.slice(0, -1);
		result += '}';
		return result;
	}

}

export function cast_de_svws_nrw_core_data_uv_UvRaum(obj: unknown): UvRaum {
	return obj as UvRaum;
}
